import axios from "axios";
import { API_BASE } from "../config";

export const performLogout = async (removeCookie) => {
  try { await axios.post(`${API_BASE}/logout`, {}, { withCredentials: true }); } catch {}

  const isProd = window.location.hostname !== "localhost";
  const domain = isProd ? ".curewiz.com" : undefined;
  const domainStr = domain ? `; domain=${domain}` : "";

  removeCookie("token", { path: "/", domain });
  removeCookie("role", { path: "/", domain });
  localStorage.removeItem("preferredPharmacyId");
  document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainStr}`;
  document.cookie = `role=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainStr}`;

  window.location.href = "/home";
};
